/*       */

import { gql } from '@apollo/client';

export default gql`
    query eventProcessesQuery($page: Int, $pageSize: Int, $where: [JSON], $orderBy: [JSON]) {
        list: processes(page: $page, itemsPerPage: $pageSize, filterBy: $where, orderBy: $orderBy) {
            id
            createDate
            name
            createdBy {
                name
            }
        }
    }
`;
